import React,{ useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Banner from '../common/Banner';
import smile from '../../images/smile.png';
import search from '../../images/search.png';
import foodDish from '../../images/food-dish.png';
import crown from '../../images/crown.png';
import postPropertyBanner from "../../images/Homepage/post-property.png";
import postPropertyBannermob from "../../images/Homepage/post-property-mob.jpg";
import questionMark from "../../images/Homepage/output.gif";
import Testimonial from '../Testimonial';
import AllLocalitiesMap from '../common/AllLocalitiesMap';
import axios from 'axios';
import FeaturedCollection from '../common/FeaturedCollection';
import AdsBannerSection from '../common/AdsBannerSection ';
import ShowcaseAdSection from '../common/ShowcaseAdSection';

const Livings = () => {


 const [allLocalities,setAllLocalities] = useState([]);
  useEffect(() => {

    const fetchAllLocalities = async () => {

      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/search/allLocalities?city_id=${1}&service=${'living'}&type=${''}`);
         setAllLocalities(response.data?.data || []); // Update suggestions state

        // console.log(response?.data?.data[0]);

      } catch (error) {
        console.error('Error fetching localities:', error);
      }
  
    };
  
    fetchAllLocalities(); 

  }, []);

  return (
    <div>
    {/* Banner */}
    <Banner category='living'/>


       {/* Featured Collections */}
     <FeaturedCollection category='living' title='Our Handpicked Collections'/>

     <AdsBannerSection />


       {/* Benefits */}
       <section className="benefit-section sectiontopgap">
        <div className="container">

          <div className="sectiontitle">
            <div className="titleunderline" data-aos='fade-right'>
              <svg width="64" height="3" viewBox="0 0 64 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 1.5H62" stroke="#EB622E" stroke-width="3" stroke-linecap="round" />
              </svg>

            </div>
            <h1 data-aos='fade-left'>Benefits Of Our PG/Co-Living</h1>
          </div>

          <div className='pg-benefits-detail d-flex justify-content-between mt-3'>
                <div className='pg-benefits-description'>
                  <img src={search} className="card-img-top" alt="DreamSakha" />
                  <p className='pg-benefits-name mb-0'>Stress free search</p>
                  <p className='pg-benefits-p mb-0 mt-2'>Real property photos and Transparent pricing</p>
                </div>
                <div className='pg-benefits-description'>
                  <img src={smile} className="card-img-top" alt="DreamSakha" />
                  <p className='pg-benefits-name mb-0'>Find your Match</p>
                  <p className='pg-benefits-p mb-0 mt-2'>Lots of options to choose from (private, twin & multi-sharing)</p>
                </div>
                <div className='pg-benefits-description'>
                  <img src={foodDish} className="card-img-top" alt="DreamSakha" />
                  <p className='pg-benefits-name mb-0'>Bon appetite</p>
                  <p className='pg-benefits-p mb-0 mt-2'>Info on meal type and offerings to know what’s cooking</p>
                </div>
                <div className='pg-benefits-description'>
                  <img src={crown} className="card-img-top" alt="DreamSakha" />
                  <p className='pg-benefits-name mb-0'>Your Life, Your Rules</p>
                  <p className='pg-benefits-p mb-0 mt-2'>Advance info on house rules to live like you do</p>
                </div>
          </div>

         
        </div>
      </section>


        {/* Top Localities */}
      {allLocalities?.length > 0 && (
     <AllLocalitiesMap allLocalities={allLocalities} category={'living'}/>
      )}

<ShowcaseAdSection />

      <section className="postProperty-section sectiontopgap">
        <Link to="/postProperty">
          <div className="container-fluid p-0">
            <div className='desk'>
              <img src={questionMark} className="banner-mark" />
              <img src={postPropertyBanner} className="banner-image" />
            </div>

            <div className='mob'>
              <img src={postPropertyBannermob} className="banner-image" />
            </div>
          </div>
        </Link>      
      </section>


      {/* Testimonials */}
     <Testimonial />

    </div>
  );
};

export default Livings;